const Envelope = (
    <g>
        <path d="m8.88006 8.827c.074.042.166.042.24 0l7.77704-4.283c-.314-1.173-1.376-2.044-2.647-2.044h-10.50004c-1.267 0-2.326.865-2.643 2.033z" />
        <path d="m9.845 10.14c-.264.146-.554.219-.844.219s-.582-.073-.846-.22l-7.155-3.95101v6.56201c0 1.517 1.233 2.75 2.75 2.75h10.5c1.517 0 2.75-1.233 2.75-2.75v-6.55001z" />
    </g>
);
export { Envelope };
